import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Price from 'shopper/components/Price/V2';
import Tag from 'shopper/components/Tag/V1';

import Image from 'components/Image';

import placeholder from 'lib/placeholder';

import GoToStoreButtonComparator from './GoToStoreButtonComparator';

import APP from 'constants/app';
import IMAGE from 'constants/image';

const PromobitRowCard = ({
  gaEventCategory,
  isPromobitHasTheBestPrice = false,
  offerCoupon,
  offerCta,
  offerId,
  offerPrice,
  offerSlug,
  offerUserVisibility,
}) => (
  <div
    className={twJoin(
      'flex w-full flex-col justify-start gap-y-4 rounded-5 border px-6 py-4 dark:border-neutral-low-200 md:flex-row md:items-center',
      isPromobitHasTheBestPrice ? 'border-primary-300' : 'border-rd-neutral-300'
    )}
  >
    <div className="grid w-full grid-cols-[auto_1fr] grid-rows-2 items-center gap-1 md:flex md:items-center md:justify-between">
      <div className="flex items-center gap-x-4">
        <Image
          alt="Promobit"
          className="h-auto w-[120px] dark:brightness-0 dark:invert lg:w-44"
          height={28}
          loading={null}
          sizes="(max-width: 1024px) 1px, 140px"
          src={IMAGE.LOGO_PATH}
          srcSet={`${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w, ${IMAGE.LOGO_PATH} 140w`}
          width={148}
          priority
        />
        {isPromobitHasTheBestPrice && (
          <Tag
            className="self-start md:order-none md:col-start-3 md:ml-0 [&>svg]:hidden md:[&>svg]:inline"
            iconLeft={<Icon name="star" />}
            type="success"
            filled
          >
            <span className="inline xl:hidden">
              {placeholder('subtitles.lowestPrice')}
            </span>
            <span className="hidden xl:inline">
              {placeholder('subtitles.lowestPriceIsOnPromobit')}
            </span>
          </Tag>
        )}
      </div>
      <Price
        className="order-3 md:order-none md:col-span-1 md:ml-auto md:mr-6"
        primaryInfo={offerPrice}
        size="size2"
      />
      <GoToStoreButtonComparator
        className="row-span-2 w-20 justify-self-end md:w-48"
        gaEventCategory={gaEventCategory}
        offerCoupon={offerCoupon}
        offerCta={offerCta}
        offerId={offerId}
        offerSlug={offerSlug}
        offerUserVisibility={offerUserVisibility}
      />
    </div>
  </div>
);

PromobitRowCard.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isPromobitHasTheBestPrice: PropTypes.bool,
  offerCta: PropTypes.string,
  offerCoupon: PropTypes.string,
  offerSlug: PropTypes.string.isRequired,
  offerUserVisibility: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerPrice: PropTypes.number.isRequired,
};

export default PromobitRowCard;
